export default __webpack_public_path__ + "static/media/gallery-wip-handle_02.68e611ad.jpg";